import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ContractStateDto, ContractStatusDto, useListContractsQuery } from "../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { urls } from "../../../../urls";
import { HomePanel } from "./HomePanel";

export const ActiveContractsPanel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const displayDate = useDisplayDate();
  const authState = useLoggedInWithOrgContextState();
  const { data, isLoading, isError } = useListContractsQuery({
    orgId: authState.selectedOrg.id,
    state: ContractStateDto.Published,
    statuses: [ContractStatusDto.Active, ContractStatusDto.Awarded].join(","),
    limit: 6,
  });
  const contracts = data?.contracts ?? [];

  return (
    <HomePanel titleKey="Active agreements" seeAllTo={urls.v2.contracts.active} isLoading={isLoading} isError={isError} isEmpty={contracts.length === 0} emptyKey="No active contracts">
      <Table variant="simple" size="sm">
        <Thead><Tr><Th>{t("Title")}</Th><Th>{t("End date")}</Th></Tr></Thead>
        <Tbody>
          {contracts.map((c) => (
            <Tr key={c.id} cursor="pointer" _hover={{ bg: "smPrimarySofter" }} onClick={() => navigate(urls.v2.contracts.view.go(c.id))}>
              <Td fontWeight="medium" color="smText">{c.title || t("Untitled")}</Td>
              <Td color="smMuted" fontSize="sm">{c.endDate ? displayDate(c.endDate) : "—"}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </HomePanel>
  );
};
